<template>
  <card>
    <div class="container">
      <div style="margin: 10px 10px 10px 10px;">
        <el-row>
          <el-col :span="18">
            <el-button type="warning" @click="dialogFormVisible = true">新增優惠</el-button>
          </el-col>
          <el-col :span="6">
            <el-input placeholder="Search" v-model="filters[0].value"></el-input>
          </el-col>
        </el-row>
      </div>

    <!-- promotions table -->
    <data-tables
      :data="tableData"
      :pagination-props="{ pageSizes: [15, 25, 50] }"
      :filters="filters"
      :table-props="tableProps"
    >
      <el-table-column label="優惠類型" prop="displayName" sortable="custom" min-width="30px">
        <template slot-scope="scope">{{scope.row.displayName}}</template>
      </el-table-column>
      <el-table-column label="優惠描述" prop="description" sortable="custom" min-width="30px">
        <template slot-scope="scope">{{scope.row.description}}</template>
      </el-table-column>
      <el-table-column label="優惠時間" prop="duration" sortable="custom" min-width="30px">
        <template slot-scope="scope">{{scope.row.start}}~{{scope.row.end}}</template>
      </el-table-column>
      <el-table-column label="啟用狀態" prop="enabled" sortable="custom" min-width="30px">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.enabled" color="green" @change="swChange(scope.row, scope.row.enabled)">
            <i class="fa fa-check" slot="on"></i>
            <i class="fa fa-exclamation" style="color:red;" slot="off"></i>
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="Actions" min-width="40px">
        <template slot-scope="scope">
            <n-button type="primary" simple="" @click.native="remove(scope.row.id)">刪除</n-button>
        </template>
      </el-table-column>
    </data-tables>
    </div>

    <n-button native-type="button" type="gray" @click.native="home()">回商店列表</n-button>

    <!-- Create new promotion -->
    <el-dialog width="40%" :visible.sync="dialogFormVisible">
      <br />
      <el-row>
        <el-col :span="24">
          <h5 class="sub-title">選擇優惠生效條件</h5>
          <el-row>
            <el-col :span="12">
              <n-radio v-model="promotionCondition.selection" label="none">沒有條件</n-radio>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" style="margin-top: 10px;">
              <n-radio v-model="promotionCondition.selection" label="order">當訂單達到...</n-radio>
            </el-col>
            <el-col :span="12">
              <el-select v-model="promotionTargets.selection" placeholder="請選擇生效條件">
                <el-option
                  v-for="(d) in promotionTargets.options"
                  :key="d.label"
                  :label="d.label"
                  :value="d.value"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <hr />
      <el-row>
        <el-col :span="24">
          <h5 class="sub-title">選擇優惠方式</h5>
          <el-row>
            <el-col :span="6" style="margin-top: 20px;">活動方式</el-col>
            <el-col :span="12">
              <el-select v-model="promotionTypes.selection" placeholder="請選擇優惠方式">
                <el-option
                  v-for="(d) in promotionTypes.options"
                  :key="d.label"
                  :label="d.label"
                  :value="d.value"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <hr />
      <el-row>
        <el-col :span="24">
          <h5>設定優惠和條件</h5>
          <el-row v-show="promotionCondition.selection == 'order'">
            <el-col :span="6" style="margin-top: 15px;">購物滿</el-col>
            <el-col :span="12">
              <el-input
                placeholder
                v-model="promotionSetting.th"
                v-if="promotionTargets.selection == 'amount'"
                v-validate="validations.thAmount"
                name="thAmount"
                :key="'thAmount'"
              >
                <template slot="prepend">NT$</template>
              </el-input>
              <el-input
                placeholder
                v-model="promotionSetting.th"
                v-else-if="promotionTargets.selection == 'number'"
                v-validate="validations.thNumber"
                name="thNumber"
                :key="'thNumber'"
              >
                <template slot="append">項商品</template>
              </el-input>
              <span class="text-primary">{{ errors.first('thAmount') }}</span>
              <span class="text-primary">{{ errors.first('thNumber') }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" style="margin-top: 15px;">折扣</el-col>
            <el-col :span="12">
              <el-input
                placeholder
                v-model="promotionSetting.value"
                v-if="promotionTypes.selection == 'fixed'"
                v-validate="validations.valueAmount"
                name="valueAmount"
                :key="'valueAmount'"
              >
                <template slot="prepend">NT$</template>
              </el-input>
              <el-input
                placeholder
                v-model="promotionSetting.value"
                v-else-if="promotionTypes.selection == 'percentage'"
                v-validate="validations.valuePercentage"
                name="valuePercentage"
                :key="'valuePercentage'"
              >
                <template slot="append">%</template>
              </el-input>
              <div v-show="promotionTypes.selection == 'percentage'">填入1-99之間任意數字。20 代表八折、60 代表四折</div>
              <span class="text-primary">{{ errors.first('valueAmount') }}</span>
              <span class="text-primary">{{ errors.first('valuePercentage') }}</span>
            </el-col>
          </el-row>
          <el-row v-if="promotionTypes.selection == 'percentage'">
            <el-col :span="6" style="margin-top: 15px;">小數點進位方式</el-col>
            <el-col :span="12">
              <!-- rounding type -->
              <el-select 
                v-model="roundingType.selection" 
                placeholder="請選擇折扣金額小數點進位方式"
                >
                <el-option
                  v-for="(d) in roundingType.items"
                  :key="d.label"
                  :label="d.label"
                  :value="d.value"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <hr />
      <el-row>
        <el-col :span="24">
          <h5>設定優惠活動時間</h5>
          <el-row>
            <el-col :span="24">
              <div class="block">
                <!-- <span class="demonstration">With quick options</span> -->
                <el-date-picker
                  v-model="timePickerValue"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="起始日期"
                  end-placeholder="結束日期"
                  :picker-options="pickerOptions"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </div>
              <span class="text-primary">優惠期間為開始日期的00:00開始，至結束日期的00:00截止</span>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <br />
      <br />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="createConfirm">確定</el-button>
      </span>
    </el-dialog>
  </card>
</template>

<script>
import ElementUI from "element-ui";
import { fetchPromotions } from "src/javascripts/eaa/fetchData";
import { createPromotion, promotionSetting } from "src/javascripts/eaa/postData";
import { deletePromotion } from "src/javascripts/eaa/deleteData";

import moment from "moment-timezone";
import { Modal } from "src/components";
import swal from "sweetalert2";
import { Collapse, CollapseItem } from "src/components";
import {
  Checkbox,
  Radio,
  Switch,
  FormGroupInput as FgInput
} from "src/components/index";
import { Validator } from "vee-validate";

var accountId = "";
var businessId = "";
var dict = {
  custom: {
    thAmount: {
      required: "必填",
      min_value: "填入大於0的數字"
    },
    thNumber: {
      required: "必填",
      min_value: "填入大於0的數字"
    },
    valueAmount: {
      required: "必填",
      min_value: "填入大於0的數字"
    },
    valuePercentage: {
      required: "必填",
      min_value: "填入數字1-99"
    }
  }
};

Validator.localize("en", dict);
export default {
  components: {
    Modal,
    Collapse,
    CollapseItem,
    [Switch.name]: Switch,
    [Radio.name]: Radio
  },
  beforeRouteEnter(to, from, next) {
    console.log("this.$route: ", to);
    // businessId = to.query.businessId;
    businessId = to.params.id;
    console.log("businessId: ", businessId);
    let fetchPromotionData = {
      businessId: businessId
    };
    // next(vm => vm.setData(res.data));
    var data = {};
    fetchPromotions(fetchPromotionData)
      .then(res => {
        console.log("fetchPromotions: ", res);
        next(vm => vm.setData(res.data));
      })
      .catch(err => {
        console.log("err: ", err);
      });
  },
  data() {
    return {
      tableData: [],
      filters: [
        {
          prop: ["displayName", "description", "duration"],
          value: ""
        }
      ],
      tableProps: {
        defaultSort: {
          prop: "displayName",
          order: "descending"
        }
      },
      dialogFormVisible: false,
      promotionTargets: {
        options: [
          {
            value: "amount",
            label: "最低金額"
          },
          {
            value: "number",
            label: "最低數量"
          }
        ],
        selection: ""
      },
      promotionTypes: {
        options: [
          {
            value: "percentage",
            label: "%折扣"
          },
          {
            value: "fixed",
            label: "固定金額折扣"
          }
        ],
        selection: ""
      },
      promotionSetting: {
        th: 0,
        value: 0
      },
      promotionCondition: {
        selection: "order",
        items: [
          {
            label: "none",
            text: "沒有條件"
          },
          {
            label: "order",
            text: "當訂單達到..."
          }
        ]
      },
      roundingType: {
        selection: 0,
        items: [
          {
            value: 1,
            label: "四捨五入"
          },
          {
            value: 0,
            label: "無條件捨去"
          }
        ]
      },
      validations: {
        thAmount: {
          required: true,
          min_value: 0
        },
        thNumber: {
          required: true,
          min_value: 0
        },
        valueAmount: {
          required: true,
          min_value: 0
        },
        valuePercentage: {
          required: true,
          min_value: 1,
          max_value: 99
        }
      },
      pickerOptions: {
        shortcuts: [{
          text: '一週',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '一個月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '三個月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      timePickerValue: ''
    };
  },
  methods: {
    setData(data) {
      this.tableData = data.map((d, index) => {
        return Object.assign(
          {},
          {
            index: index,
            id: d.id,
            displayName: d.displayName,
            description: d.description,
            class: d.class,
            content: d.content,
            start: moment(d.content.start)
              .tz("Asia/Taipei")
              .format("YYYY-MM-DD"),
            end: moment(d.content.end)
              .tz("Asia/Taipei")
              .format("YYYY-MM-DD"),
            duration: `${moment(d.content.start)
              .tz("Asia/Taipei")
              .format("YYYY-MM-DD")}~${moment(d.content.end)
              .tz("Asia/Taipei")
              .format("YYYY-MM-DD")}`,
            enabled: d.enabled
          }
        );
      });
      console.log(this.tableData);
    },
    edit(row) {
      console.log("edit", row);
      this.modals.newContract = true;
    },
    createModal() {
      console.log("create");
      let options = this.plans.map(d => {
        return Object.assign(
          {},
          {
            id: d.id,
            name: d.plan
          }
        );
      });
      this.modals.newContract = true;
      this.newContractData = Object.assign(
        {},
        {
          options: options,
          start: "",
          end: "",
          selectedPlan: "",
          sysEnd: "",
          status: "normal"
        }
      );
    },
    create() {},
    stop() {
      console.log("stop");
      disable(accountId)
        .then(res => {
          window.location.reload();
        })
        .catch(err => {
          console.log("err: ", err);
        });
    },
    start() {
      console.log("start");
      enable(accountId)
        .then(res => {
          window.location.reload();
        })
        .catch(err => {
          console.log("err: ", err);
        });
    },
    selectChange() {
      console.log("selectChange: ", this.newContractData.selectedPlan);
    },
    home: function() {
      window.history.back();
    },

    promotionReset() {
      this.promotionTargets = {
        options: [
          {
            value: "amount",
            label: "最低金額"
          },
          {
            value: "number",
            label: "最低數量"
          }
        ],
        selection: ""
      };
      this.promotionTypes = {
        options: [
          {
            value: "percentage",
            label: "%折扣"
          },
          {
            value: "fixed",
            label: "固定金額折扣"
          }
        ],
        selection: ""
      };
      this.promotionSetting = {
        th: 0,
        value: 0
      };
      this.promotionCondition = {
        selection: "order",
        items: [
          {
            label: "none",
            text: "沒有條件"
          },
          {
            label: "order",
            text: "當訂單達到..."
          }
        ]
      };
      this.timePickerValue = '';
    },
    createConfirm() {
      console.log("this.timePickerValue: ", this.timePickerValue);
      this.$validator.validateAll().then(valid => {
        console.log("valid: ", valid);
        if (valid) {
          console.log("this.promotionCondition: ", this.promotionCondition);
          console.log("this.promotionTargets: ", this.promotionTargets);
          console.log("this.promotionTypes: ", this.promotionTypes);
          console.log("this.promotionSetting: ", this.promotionSetting);
          let condition = this.promotionCondition.selection; // none or order
          let target = this.promotionTargets.selection; // amount or number
          let type = this.promotionTypes.selection; // fixed or percentage
          let roundingType = this.roundingType.selection; // 0(無條件捨去) or 1（四捨五入）

          let targetTh = condition === "none" ? 0 : this.promotionSetting.th;
          let targetValue = this.promotionSetting.value;
          let displayTarget =
            target == "amount" ? "金額" : target == "number" ? "數量" : target;
          let displayType =
            type == "fixed" ? "元" : type == "percentage" ? "%" : type;
          let displayRoundingType =
            roundingType == 0 ? "（無條件捨去）" : "（四捨五入）";
          var description = "";
          if (condition === "none") {
            description = `折${targetValue}${displayType}`;
          } else {
            description = `${displayTarget}滿${targetTh}折${targetValue}${displayType}`;
          }
          if(type == 'percentage') {
            description = description + displayRoundingType;
          }
          let promotion = {
            displayName: "一般折扣",
            description: description,
            class: "common",
            content: {
              type: type,
              target: target,
              th: targetTh,
              value: targetValue,
              start: moment(this.timePickerValue[0])
                .tz("Asia/Taipei")
                .format("YYYY-MM-DD"),
              end: moment(this.timePickerValue[1])
                .tz("Asia/Taipei")
                .format("YYYY-MM-DD")
            },
            duration: `${moment(this.timePickerValue[0])
              .tz("Asia/Taipei")
              .format("YYYY-MM-DD")}~${moment(this.timePickerValue[1])
              .tz("Asia/Taipei")
              .format("YYYY-MM-DD")}`,
            enabled: false
          };
          promotion.index = this.tableData.length;
          promotion.start = promotion.content.start;
          promotion.end = promotion.content.end;
          promotion.roundingType = this.roundingType.selection;
          /** todo
           * insert into db
           */
          let createPromotionData = {
            businessId,
            promotion
          };
          console.log("createPromotionData: ", createPromotionData);
          createPromotion(createPromotionData)
            .then(res => {
              console.log("createPromotionRes: ", res.data);
              this.$message({
                type: "success",
                message: "新增成功"
              });
              promotion.id = res.data.insertId;
              this.tableData.push(promotion);
              this.promotionReset();
              this.dialogFormVisible = false;
            })
            .catch(err => {
              console.log("err: ", err);
              this.$message({
                type: "error",
                message: err.message
              });
            });
        }
      });
    },
    editConfirm(content) {
      console.log(content);
    },
    remove(id) {
      swal.fire({
        title: `確定要刪除優惠活動嗎？`,
        buttonsStyling: true,
        // confirmButtonClass: "btn btn-success btn-fill",
        showCancelButton: true,
        confirmButtonColor: "#f96332",
        cancelButtonColor: "#cccccc",
        confirmButtonText: "刪除"
      }).then(res => {
        console.log("res: ", res);
        if (res.value) {
          let data = {
            id,
            businessId
          };
          deletePromotion(data)
            .then(deletePromotionRes => {
              let _index = this.tableData.findIndex(d => d.id == id);
              this.tableData.splice(_index, 1);
              this.$message({
                type: "success",
                message: "刪除成功！"
              });
            })
            .catch(err => {
              this.$message({
                type: "error",
                message: err.message
              });
            });
        }
      });
    },
    swChange(d, enabledValue) {
        let _index = d.index;
        let promotionSettingData = {
            id: d.id,
            class: d.class,
            businessId: businessId
        };
        promotionSetting(promotionSettingData)
        .then(res => {
            this.$message({
                type: "success",
                message: "已更改"
            });
        })
        .catch(err => {
            console.log("err: ", err)
            this.$message({
                type: "error",
                message: err.data.error
            });
            this.tableData[_index].enabled = false;
        })
    }
  }
  // updated: function() {

  // }
};
</script>
